export const AUTH_STORAGE_KEYS = {
  TOKEN: 'token',
  USER: 'user',
} as const;

export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  VERIFY_OTP: '/verify-otp',
  ONBOARDING: '/onboarding',
  DASHBOARD: '/dashboard/home',
  SETUP_ORGANISATION: '/auth/setup-organisation',
} as const;

export const PROTECTED_ROUTES = [
  ROUTES.DASHBOARD,
  ROUTES.ONBOARDING,
  ROUTES.SETUP_ORGANISATION,
  ROUTES.VERIFY_OTP,
] as const;

export const PUBLIC_ROUTES = [ROUTES.LOGIN, ROUTES.HOME] as const;

export const AUTH_FLOW = {
  NEEDS_ONBOARDING: 'NEEDS_ONBOARDING',
  NEEDS_ORGANISATION: 'NEEDS_ORGANISATION',
  COMPLETE: 'COMPLETE',
} as const;

export const ONBOARDING_ROUTES = [ROUTES.ONBOARDING, ROUTES.SETUP_ORGANISATION] as const;

export const COMPANY_SIZES = ['1-10', '11-50', '51-200', '201-500', '501-1000', '1000+'] as const;

export const COMPANY_DOMAINS = [
  'Technology',
  'Healthcare',
  'Finance',
  'Education',
  'Manufacturing',
  'Retail',
  'Other',
] as const;

export const ROLES = {
  ADMIN: 'ADMIN',
  RECRUITER: 'RECRUITER',
  HIRING_MANAGER: 'HIRING_MANAGER',
} as const;

export function isHiringManagerLike(role?: string): boolean {
  return role === ROLES.HIRING_MANAGER;
}

export const DESIGNATIONS = [
  'CEO',
  'CTO',
  'HR Manager',
  'Hiring Manager',
  'Recruiter',
  'Other',
] as const;

export const Department = {
  ENGINEERING_SOFTWARE_DEVELOPMENT: 'ENGINEERING_SOFTWARE_DEVELOPMENT',
  SALES: 'SALES',
  MARKETING: 'MARKETING',
  HUMAN_RESOURCES: 'HUMAN_RESOURCES',
  FINANCE_ACCOUNTS: 'FINANCE_ACCOUNTS',
  OPERATIONS: 'OPERATIONS',
  CUSTOMER_SUPPORT: 'CUSTOMER_SUPPORT',
  PRODUCT_MANAGEMENT: 'PRODUCT_MANAGEMENT',
  DATA_ANALYTICS: 'DATA_ANALYTICS',
  IT_INFRASTRUCTURE: 'IT_INFRASTRUCTURE',
  BUSINESS_DEVELOPMENT: 'BUSINESS_DEVELOPMENT',
  HR_RECRUITMENT: 'HR_RECRUITMENT',
  QA_TESTING: 'QA_TESTING',
  UX_DESIGN: 'UX_DESIGN',
} as const;

export type Department = typeof Department[keyof typeof Department];

export const DEPARTMENT_SEEDS: Array<{ id: Department; name: string }> = [
  { id: Department.ENGINEERING_SOFTWARE_DEVELOPMENT, name: 'Engineering / Software Development' },
  { id: Department.SALES, name: 'Sales' },
  { id: Department.MARKETING, name: 'Marketing' },
  { id: Department.HUMAN_RESOURCES, name: 'Human Resources (HR)' },
  { id: Department.FINANCE_ACCOUNTS, name: 'Finance / Accounts' },
  { id: Department.OPERATIONS, name: 'Operations' },
  { id: Department.CUSTOMER_SUPPORT, name: 'Customer Support / Technical Support' },
  { id: Department.PRODUCT_MANAGEMENT, name: 'Product Management' },
  { id: Department.DATA_ANALYTICS, name: 'Data & Analytics' },
  { id: Department.IT_INFRASTRUCTURE, name: 'IT / Infrastructure / Helpdesk' },
  { id: Department.BUSINESS_DEVELOPMENT, name: 'Business Development' },
  { id: Department.HR_RECRUITMENT, name: 'HR & Recruitment' },
  { id: Department.QA_TESTING, name: 'QA / Testing' },
  { id: Department.UX_DESIGN, name: 'UX / Design' },
];
